import customDimensions from './dimension';

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    gtag:any;
  }
}

export const GA_TRACKING_ID = "UA-200261383-1";

export const init = () => {
  return {
    __html: `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${GA_TRACKING_ID}',{page_path: window.location.pathname,});`,
  };
}

export const pageview = (url: URL) => {
  window.gtag("config", GA_TRACKING_ID, {
    page_path: url
  });
};

export const overallEvent = (action: string, label: string, requestId: string = undefined) => {
  let category = 'resizer';
  if(window.location.pathname.split('/').pop() === 'image-rotator' ) {
    category = 'rotator'
  }
  
  if(window.location.pathname.split('/').pop() === 'image-flipper' ) {
    category = 'flipper'
  }
  
  if(window.location.pathname.split('/').pop() === 'image-cropper' ) {
    category = 'cropper'
  }
  

  sendEvent(category, action, label, requestId);
};

const sendEvent = (category: string, action: string, label: string, requestId: string) => {
  if (typeof window.gtag !== 'undefined')
    window.gtag("event", action, Object.assign({
      event_category: category,
      event_label: label
    }, customDimensions(requestId)));
};